import { showSwal } from '../pages/sweet-alert.js';

/**
 * Enhanced Leads Alpine.js Component
 * Handles lead management functionality with improved error handling and organization
 */
import $ from "jquery";
import initLeadModal, {initNewLeadModal} from "./leadModalComponent.js";

export default function leadsComponent() {
    // Initialize date range with current month
    const currentMonth = window.moment ? window.moment() : new Date();
    const fromDate = window.moment ? currentMonth.startOf('month').format('YYYY-MM-DD') : '';
    const toDate = window.moment ? currentMonth.endOf('month').format('YYYY-MM-DD') : '';



    return {
        // Data properties
        fromDate: fromDate,
        toDate: toDate,
        totalLeads: null,
        orderLeads: null,
        unSuccessLeads: null,
        followUpCalls: null,
        todayFollowUp: null,
        orderFollowUpsCount: null,
        orderFollowUps: [],
        tasks: [],
        clientFollowupLeads: [],
        agentFollowupLeads: [],
        validationQuestions: [],
        loading: false,
        error: null,

        // Initialize and setup methods
        initLeads(authID = null) {
            console.log('Leads component initialized for user:', authID);
            if (authID) this.loadAgentDashboard(authID);
            this.setupEventListeners();
            // Dynamic location filters
            this.setupLocationFilters();
        },

        setupEventListeners() {
            if (window.EchoUtils?.isConnected()) {
                window.EchoUtils.listen('public', 'lead-updates', '.lead.updated', (data) => {
                    this.handleLeadUpdate(data);
                });
            }
        },

        handleLeadUpdate(data) {
            console.log('Lead update received:', data);
            this.refreshDataTable();
            this.showNotification('Lead Updated', `Lead ${data.lead_id} has been updated`);
        },

        // Dashboard and data loading
        async loadAgentDashboard(userId) {
            if (!userId) return;

            this.setLoading(true);
            try {
                const response = await window.axios.get(`/api/leads/${userId}/agentData`, {
                    params: { fromDate: this.fromDate, toDate: this.toDate }
                });
                Object.assign(this, response.data);
                console.log('Agent dashboard data loaded successfully');
            } catch (error) {
                this.handleError('Failed to load dashboard data', error);
            } finally {
                this.setLoading(false);
            }
        },

        filterLeads() {
            try {
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to filter leads', error);
            }
        },

        setupLocationFilters() {
            $('#filter_countries').change(function() {
                if($(this).val() != '') {
                    var value = $(this).val();
                    var dependent = $(this).data('dependent');

                    axios.post(`/api/countries/get-governments`, {
                        value: value,
                        dependent: dependent,
                    })
                        .then(function (response) {
                            $(`#${dependent}`).html(response.data);
                        });
                }
            });

            $('.dynamic').change(function() {
                var value = $(this).val();
                var dependent = $(this).data('dependent');
                var urlData;

                if (dependent == 'filter_areas') {
                    urlData = '/api/governments/get-areas';
                } else if (dependent == 'filter_regions') {
                    urlData = '/api/regions/getRegions';
                } else {
                    initializeDatatable();
                    return true;
                }

                axios.post(`${urlData}`, {
                    value: value,
                    dependent: dependent,
                })
                    .then(function (response) {
                        $('#'+dependent).html(response.data);
                        initializeDatatable();
                    });
            });
        },


        // Lead CRUD operations
        async createLead(event) {
            event.preventDefault();
            this.setLoading(true);

            try {
                const formElements = this.getFormElements();
                if (!this.validateCreateForm(formElements)) return;

                const leadData = this.prepareLeadData(formElements);
                const response = await window.axios.post('/api/leads/store', leadData);

                this.handleCreateSuccess(response);
            } catch (error) {
                this.handleCreateError(error);
            } finally {
                this.setLoading(false);
            }
        },

        async updateLead(event, id) {
            event.preventDefault();
            if (!id) {
                this.showError('Lead ID is required');
                return;
            }

            this.setLoading(true);
            try {
                const updateData = this.prepareUpdateData(id);
                if (!this.validateUpdateData(updateData, id)) return;

                const response = await window.axios.post(`/api/leads/${id}/update`, updateData);
                await this.handleUpdateSuccess(response, updateData, id);
            } catch (error) {
                this.handleUpdateError(error);
            } finally {
                this.setLoading(false);
            }
        },

        // Form handling helpers
        getFormElements() {
            const getElement = (id) => document.getElementById(id);
            return {
                name: getElement('leadname'),
                phone: getElement('leadphone'),
                whatsapp_number: getElement('leadwhatsapp_number'),
                phone_2: getElement('leadphone_2'),
                address: getElement('leadaddress'),
                traffic_source: getElement('lead-source'),
                country: getElement('leadcountry'),
                government: getElement('leadgovernment'),
                area: getElement('leadarea'),
                region_id: getElement('leadregion'),
                call_note: getElement('leadnote'),
                agent_id: getElement('lead-user'),
                total_price: getElement('leadtotalprice'),
                paymentMethod: getElement('paymentMethod')
            };
        },

        validateCreateForm(elements) {
            const requiredFields = ['name', 'phone'];
            const missingFields = requiredFields.filter(field =>
                !elements[field]?.value?.trim()
            );

            if (missingFields.length > 0) {
                this.showError(`Required fields missing: ${missingFields.join(', ')}`);
                return false;
            }
            return true;
        },

        prepareLeadData(elements) {
            const { product_id, quantity, price } = this.getProductData();
            return {
                name: elements.name?.value || '',
                phone: elements.phone?.value || '',
                whatsapp_number: elements.whatsapp_number?.value || '',
                phone_2: elements.phone_2?.value || '',
                address: elements.address?.value || 'No Address',
                country_id: elements.country?.value || '',
                government: elements.government?.value || '',
                traffic_source: elements.traffic_source?.value || '',
                area: elements.area?.value || '',
                region_id: elements.region_id?.value || '',
                product_id,
                quantity,
                price,
                total_price: elements.total_price?.value || 0,
                call_note: elements.call_note?.value || '',
                user_id: elements.agent_id?.value || '',
                payment_method_id: elements.paymentMethod?.value || ''
            };
        },

        getProductData() {
            const product_id = [];
            const quantity = [];
            const price = [];

            document.querySelectorAll('.product-select').forEach(select => {
                if (select.value) product_id.push(select.value);
            });
            document.querySelectorAll('.leadamount').forEach(input => {
                quantity.push(input.value || 1);
            });
            document.querySelectorAll('.leadprice').forEach(input => {
                price.push(input.value || 0);
            });

            return { product_id, quantity, price };
        },

        prepareUpdateData(id) {
            const getElement = (elementId) => document.getElementById(elementId);

            const basicData = {
                name: getElement(`leadname-${id}`)?.value || '',
                phone_2: getElement(`leadphone_2-${id}`)?.value || '',
                whatsapp_number: getElement(`leadwhatsnumber-${id}`)?.value || '',
                address: getElement(`leadaddress-${id}`)?.value || '',
                country: getElement(`leadcountry-${id}`)?.value || '',
                government: getElement(`leadgovernment-${id}`)?.value || '',
                area: getElement(`leadarea-${id}`)?.value || '',
                region_id: getElement(`leadregion-${id}`)?.value || '',
                total_price: getElement(`leadtotalprice-${id}`)?.value || 0,
                payment_method_id: getElement(`paymentmethod-${id}`)?.value || '',
                call_status: getElement(`leadcallstatus-${id}`)?.value || '',
                reschedule_time: getElement(`leadrescheduletime-${id}`)?.value || '',
                call_note: getElement(`leadnote-${id}`)?.value || '',
                agent_id: getElement(`leaduser-${id}`)?.value || '',
                client_availability: getElement(`availabilty-${id}`)?.value || '',
                cancelled_reason: getElement(`leadCancelledReason-${id}`)?.value || '',
                client_type: getElement(`type-${id}`)?.value || '',
                follow_type: getElement(`follow-type-${id}`)?.value || ''
            };

            // Get address data
            const address_data = {};
            document.getElementsByName(`leadaddressdata-${id}[]`).forEach(element => {
                if (element.dataset.title) {
                    address_data[element.dataset.title] = element.value;
                }
            });

            // Get location data
            const location = Array.from(document.getElementsByName(`location-${id}[]`))
                .map(el => el.value || '');

            // Get product data
            const { product_id, quantity, price } = this.getUpdateProductData();

            // Get questions data
            const questions = this.getQuestionsData(id);

            return {
                ...basicData,
                address_data,
                location,
                product_id,
                quantity,
                price,
                questions: this.cleanQuestions(questions, id)
            };
        },

        getUpdateProductData() {
            const product_id = [];
            const quantity = [];
            const price = [];

            document.querySelectorAll('div.pro2 .product-select').forEach(select => {
                if (select.value) product_id.push(select.value);
            });
            document.querySelectorAll('div.pro2 .leadamount').forEach(input => {
                quantity.push(input.value || 1);
            });
            document.querySelectorAll('div.pro2 .leadprice').forEach(input => {
                price.push(input.value || 0);
            });

            return { product_id, quantity, price };
        },

        getQuestionsData(id) {
            const questionFields = [
                'age', 'weight', 'product_time', 'smoking', 'smoking_note',
                'patient_pressure', 'patient_pressure_note', 'patient_sugar', 'patient_sugar_note',
                'sexual_drugs', 'sexual_drugs_note', 'other_diseases', 'other_diseases_note',
                'product_result', 'product_result_note'
            ];

            const questions = {};
            questionFields.forEach(field => {
                const element = document.getElementById(`${field}-${id}`);
                if (element) questions[field] = element.value;
            });

            return questions;
        },

        cleanQuestions(questions, id) {
            this.validationQuestions = [];

            for (const [key, value] of Object.entries(questions)) {
                if (!value) {
                    const element = document.getElementById(`${key}-${id}`);
                    if (element?.hasAttribute('required')) {
                        this.validationQuestions.push(key);
                    }
                    delete questions[key];
                }
            }

            return questions;
        },

        validateUpdateData(data, id) {
            if (data.call_status === 'confirmed') {
                if (!data.region_id) {
                    this.showError('Region is required for confirmed orders');
                    return false;
                }

                const deliverDate = document.getElementById(`deliver_date-${id}`)?.value;
                const deliverTime = document.getElementById(`deliver_time-${id}`)?.value;

                if (!deliverDate || !deliverTime) {
                    this.showError('Delivery date and time are required');
                    return false;
                }

                const addressData = data.address_data || {};
                const requiredFields = ['street', 'buildingName', 'floorNumber', 'apartmentNumber'];
                if (requiredFields.some(field => !addressData[field])) {
                    this.showError('Complete delivery address is required');
                    return false;
                }
            }
            return true;
        },

        // Success/Error handlers
        handleCreateSuccess(response) {
            document.getElementById('newLeadForm')?.reset();
            document.getElementById('leadModalClose')?.click();
            this.showSuccess(response.data.message || 'Lead created successfully');
            this.refreshDataTable();
        },

        handleCreateError(error) {
            console.error('Lead creation failed:', error);
            if (error.response?.data?.errors) {
                this.showValidationErrors(error.response.data.errors);
            } else {
                this.showError('Failed to create lead. Please try again.');
            }
        },

        async handleUpdateSuccess(response, updateData, id) {
            console.log('Lead updated successfully:', response.data);

            if (updateData.call_status === 'confirmed') {
                await this.createOrderFromLead(id, updateData);
            }

            const closeButton = document.getElementById(`leadModalClose-${id}`);
            if (closeButton) {
                closeButton.removeAttribute('disabled');
                closeButton.style.pointerEvents = 'auto';
                closeButton.click();
            }

            this.showSuccess(response.data.message || 'Lead updated successfully');
            this.refreshDataTable();
        },

        handleUpdateError(error) {
            console.error('Lead update failed:', error);
            this.showError('Failed to update lead. Please try again.');
        },

        async createOrderFromLead(leadId, updateData) {
            try {
                const orderData = {
                    place: document.getElementById(`order-place-${leadId}`)?.value || '',
                    lead_id: leadId,
                    date: document.getElementById(`deliver_date-${leadId}`)?.value || '',
                    time: document.getElementById(`deliver_time-${leadId}`)?.value || '',
                    notes: document.getElementById(`notes-${leadId}`)?.value || '',
                    government: updateData.government
                };

                await window.axios.post('/api/order/new', orderData);
                this.showSuccess('Order created successfully');
            } catch (error) {
                console.error('Order creation failed:', error);
                this.showError('Lead updated but order creation failed');
            }
        },

        // Bulk operations
        async bulkAssign(event, typeAssignment) {
            const selectedLeads = this.getSelectedLeads();
            if (selectedLeads.length === 0) {
                this.showError('Please select leads to assign');
                return;
            }

            let selectedAgent, agentId;
            const selectorId = typeAssignment === 'Assign To Agent' ? 'bulk-assign-lead' : 'bulk-assign-lead-to-tl';
            const selector = document.getElementById(selectorId);

            selectedAgent = selector?.value;
            agentId = selector?.dataset.employee;

            if (!selectedAgent) {
                this.showError(`Please select ${typeAssignment.toLowerCase()}`);
                return;
            }

            const confirmed = await this.confirmAction(
                'Are you sure?',
                `You will assign ${selectedLeads.length} leads`
            );

            if (!confirmed) return;

            try {
                const response = await window.axios.post('/api/leads/assignBulk', {
                    call_agent: selectedAgent,
                    bulk_leads: selectedLeads,
                    agent_id: agentId,
                    type_assignment: typeAssignment
                });

                this.showSuccess(response.data.message || 'Leads assigned successfully');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to assign leads', error);
            }
        },

        async bulkClearDataLead(event, type, id = null) {
            const confirmed = await this.confirmAction(
                'Are you sure?',
                'You will reset the selected leads data'
            );

            if (!confirmed) return;

            try {
                const payload = { type, agent_id: this.getCurrentAgentId() };

                if (type === 'clearDataLead' && id) {
                    payload.lead = id;
                } else if (type === 'clearDataLeads') {
                    payload.selected_agent = this.getSelectedLeads();
                }

                const response = await window.axios.post('/api/leads/bulkClearDataLead', payload);
                this.showSuccess(response.data.message || 'Lead data cleared successfully');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to clear lead data', error);
            }
        },

        async bulkClearNoteLead(event, type, id = null) {
            const confirmed = await this.confirmAction(
                'Are you sure?',
                'You will clear notes for the selected leads'
            );

            if (!confirmed) return;

            try {
                const payload = { type, agent_id: this.getCurrentAgentId() };

                if (type === 'clearNoteLead' && id) {
                    payload.lead = id;
                } else if (type === 'clearNoteLeads') {
                    payload.selected_agent = this.getSelectedLeads();
                }

                const response = await window.axios.post('/api/leads/bulkClearNoteLead', payload);
                this.showSuccess(response.data.message || 'Notes cleared successfully');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to clear notes', error);
            }
        },

        async bulkTrash(event) {
            const selectedLeads = this.getSelectedLeads();
            if (selectedLeads.length === 0) {
                this.showError('Please select leads to delete');
                return;
            }

            const confirmed = await this.confirmAction(
                'Are you sure?',
                `You will delete ${selectedLeads.length} leads permanently`
            );

            if (!confirmed) return;

            try {
                const response = await window.axios.post('/api/leads/multipleTrash', {
                    ids: selectedLeads
                });
                this.showSuccess(response.data.message || 'Leads deleted successfully');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to delete leads', error);
            }
        },

        // Individual operations
        async updateNoAnswer(event, id) {
            try {
                const agentId = document.getElementById(`leaduser-${id}`)?.value;
                const callNote = document.getElementById(`leadnote-${id}`)?.value;

                const response = await window.axios.post(`/api/leads/${id}/updatenoanswer`, {
                    agent_id: agentId,
                    call_note: callNote
                });

                const closeButton = document.getElementById(`leadModalClose-${id}`);
                if (closeButton) {
                    closeButton.removeAttribute('disabled');
                    closeButton.style.pointerEvents = 'auto';
                    closeButton.click();
                }

                this.showSuccess(response.data.message || 'Lead updated with no answer');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to update lead', error);
            }
        },

        async resetSuspend(event, id) {
            try {
                await window.axios.post(`/api/leads/${id}/resetSuspend`);
                console.log('Lead suspend status reset');
            } catch (error) {
                this.handleError('Failed to reset suspend status', error);
            }
        },

        async trashLead(id) {
            const confirmed = await this.confirmAction(
                'Are you sure?',
                'You will trash this lead'
            );

            if (!confirmed) return;

            try {
                const response = await window.axios.delete(`/api/leads/trash/${id}`);
                this.showSuccess(response.data.message || 'Lead trashed successfully');
                this.refreshDataTable();
            } catch (error) {
                this.handleError('Failed to trash lead', error);
            }
        },

        // View operations
        async viewLead(id) {


            try {

                const statusResponse = await window.axios.get(`/api/leads/${id}/checkLeadStatus`);
                const status = statusResponse.data.data.status;

                if (status === 'suspended') {
                    this.showError('This lead is currently being viewed by another agent');
                    return;
                }

                await this.loadModal(`/lead/view/${id}`, 'addEditModal');




                // Extract values from the modal DOM and initialize modal JS
                const $modal = $('#addEditModal');
                const leadId = $modal.find('form[data-lead-id]').data('lead-id');
                const whatsappNumber = $modal.find('input[name="whats_number"]').val() || $modal.find('.badge.bg-success').text().trim();
                const phone = $modal.find('.btn.btn-success.btn-lg').first().text().trim();
                const lat = $modal.find('input[id^="latitude-"]').val() || null;
                const lng = $modal.find('input[id^="longitude-"]').val() || null;
                const location = [lat, lng];

                // Ensure new lead modal always initializes JS logic after shown
                initLeadModal({
                    leadId,
                    whatsappNumber,
                    phone,
                    location
                });

            } catch (error) {
                this.handleError('Failed to view lead', error);
            }
        },

        async newLeadModal(event) {
            initNewLeadModal()
        },

        async showLeadModal(id) {
            try {
                await this.loadModal(`/lead/${id}/manage`, 'addEditModal');
            } catch (error) {
                this.handleError('Failed to show lead modal', error);
            }
        },

        async loadModal(url, modalId) {
            const modal = document.getElementById(modalId);
            if (!modal) return;

            const modalContent = modal.querySelector('.modal-content');
            if (!modalContent) return;

            // Show loading
            modalContent.innerHTML = '<div class="text-center p-4"><div class="spinner-border" role="status"></div></div>';

            try {
                const response = await fetch(url);
                const html = await response.text();
                modalContent.innerHTML = html;

                this.initializeModalComponents(modal);

                const bootstrapModal = new window.bootstrap.Modal(modal);
                bootstrapModal.show();
            } catch (error) {
                console.error('Failed to load modal content:', error);
                modalContent.innerHTML = '<div class="alert alert-danger">Failed to load content</div>';
            }
        },

        initializeModalComponents(modal) {
            // Re-initialize Select2
            if (window.$ && window.$.fn.select2) {
                modal.querySelectorAll('.select2').forEach(element => {
                    if (!element.classList.contains('select2-hidden-accessible')) {
                        window.$(element).select2({
                            theme: 'bootstrap-5',
                            placeholder: "Select an option",
                            allowClear: true,
                            width: '100%',
                            dropdownParent: window.$(modal)
                        });
                    }
                });
            }

            // Re-initialize date pickers
            if (window.flatpickr) {
                modal.querySelectorAll('.datepicker').forEach(element => {
                    window.flatpickr(element, {
                        dateFormat: 'Y-m-d',
                        allowInput: true
                    });
                });
            }

            // Re-initialize Feather icons
            if (window.feather) {
                window.feather.replace();
            }
        },

        // Utility methods
        copyURLToPBI(event, id) {
            try {
                const url = window.tableUrl || '';
                const { origin } = window.location;
                const finalUrl = `${origin}/api/leads/${id}/get-leads-data?${url.slice(url.indexOf('?') + 1)}`;

                this.copyToClipboard(finalUrl);
            } catch (error) {
                this.handleError('Failed to copy URL', error);
            }
        },

        async copyToClipboard(text) {
            try {
                if (navigator.clipboard) {
                    await navigator.clipboard.writeText(text);
                    this.showSuccess('URL copied to clipboard');
                } else {
                    this.fallbackCopyText(text);
                }
            } catch (error) {
                this.fallbackCopyText(text);
            }
        },

        fallbackCopyText(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                this.showSuccess('URL copied to clipboard');
            } catch (error) {
                this.showError('Failed to copy URL');
            } finally {
                document.body.removeChild(textArea);
            }
        },

        getSelectedLeads() {
            return Array.from(document.querySelectorAll('input[name="check_item"]:checked'))
                .map(checkbox => checkbox.value)
                .filter(value => value);
        },

        getCurrentAgentId() {
            return document.getElementById('bulk-assign-lead')?.dataset.employee || '';
        },

        refreshDataTable() {
            if (window.initializeDatatable && typeof window.initializeDatatable === 'function') {
                window.initializeDatatable();
            }
        },

        // UI feedback methods
        setLoading(loading) {
            this.loading = loading;
        },

        async confirmAction(title, text) {
            if (window.AppUtils?.confirm) {
                const result = await window.AppUtils.confirm(title, text);
                return result.isConfirmed;
            } else if (window.Swal) {
                const result = await window.Swal.fire({
                    title,
                    text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                });
                return result.isConfirmed;
            } else {
                return confirm(`${title}\n${text}`);
            }
        },

        showSuccess(message) {
            this.showAlert(message, 'success');
        },

        showError(message) {
            this.showAlert(message, 'error');
        },

        showNotification(title, message) {
            if (window.SwalToast) {
                window.SwalToast.fire({
                    icon: 'info',
                    title,
                    text: message
                });
            }
        },

        showAlert(message, type = 'info') {
            if (window.showSwal) {
                window.showSwal(type, message);
            } else if (window.Swal) {
                window.Swal.fire({
                    title: type === 'error' ? 'Error' : 'Success',
                    text: message,
                    icon: type === 'error' ? 'error' : 'success',
                    timer: type === 'error' ? null : 3000
                });
            } else {
                alert(message);
            }
        },

        showValidationErrors(errors) {
            let errorMessage = '';
            for (const [key, messages] of Object.entries(errors)) {
                errorMessage += `${key}: ${Array.isArray(messages) ? messages.join(', ') : messages}\n`;
            }

            if (window.Swal) {
                window.Swal.fire({
                    title: 'Validation Errors',
                    html: Object.entries(errors)
                        .map(([key, messages]) =>
                            `<div class="alert alert-danger mb-2">${key}: ${Array.isArray(messages) ? messages.join(', ') : messages}</div>`
                        ).join(''),
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            } else {
                alert(errorMessage);
            }
        },

        handleError(message, error = null) {
            console.error(message, error);
            this.error = message;
            this.showError(message);
        }
    };
}


